import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HTTP } from "@ionic-native/http";
import 'rxjs/add/operator/timeout';

@Injectable()

export class MeasurementService {

  testoNativeUrls = [
    'http://192.168.43.1:55000/data', // testo 300
    'http://192.168.43.1:55000/data', // testo 300 (2x i.v.m. soms result header code -1)
  ];

  testoUrls = [
    'http://127.0.0.1:53757/data', // testo 320/330 LX
    'http://127.0.0.1:55000/data', // test 330i LX
    //'https://testosim.maintenanz.ecologium.nl/sim.php', // Simulatie
    //'https://nuc.ecologium.nl/maintenanz/testosim/sim.php', // Simulatie
    //'http://nuc.ecologium.nl/maintenanz/testosim/sim.php', // Simulatie
    //'http://10.10.13.25/maintenanz/testosim/sim.php', // Simulatie
  ];

  timeout = 2000;
  timeoutSeconds = 5;
  measuring = false;
  measuringInterval = 1500;

  constructor(
    private http: HttpClient,
    private httpNative: HTTP
  ) {}

  private getDevice(target_device?: string){
    return new Promise((resolve, reject) => {
      let found = false;
      let scanned = 0;
      let total = this.testoUrls.length + this.testoNativeUrls.length;
      if(target_device != 'testo300'){
        for(let i = 0; i < this.testoUrls.length; i++){
          let url = this.testoUrls[i];
          // Try HttpClient
          this.http.get(url).timeout(this.timeout).subscribe((data) => {
            if(!found){
              found = true;
              console.log('MeasurementService.getDevice HttpClient success, device index = ' + i);
              resolve({ device_index: i, native: false });
            }
          }, (error) => {
            console.log('MeasurementService.getDevice HttpClient error: ' + url);
            console.error(error);
            scanned++;
            if(scanned == total){
              reject();
            }
          });
        }
      }
      if(target_device == 'testo300' || target_device == 'ios') {
        for (let i = 0; i < this.testoNativeUrls.length; i++) {
          let url = this.testoNativeUrls[i];
          // Try Native HTTP
          this.httpNative.setRequestTimeout(this.timeoutSeconds);
          this.httpNative.get(url, {}, {}).then(data => {
            console.log('MeasurementService.getDevice native success, device index = ' + i);
            if (!found) {
              found = true;
              resolve({device_index: i, native: true});
            }
          }).catch(error => {
            if(error.status == 404 && error.error){
              // Testo 300 header code 404 fix
              if (!found) {
                found = true;
                resolve({device_index: i, native: true});
              }
            } else {
              console.log('MeasurementService.getDevice native error: ' + url);
              console.log(JSON.stringify(error));
              scanned++;
              if (scanned == total) {
                reject();
              }
            }
          });
        }
      }
    });
  }

  public startMeasurement(callback, target_device?: string){
    return new Promise((resolve, reject) => {
      this.getDevice(target_device).then((device) => {
        // @ts-ignore
        let device_index = device.device_index;
        // @ts-ignore
        let native = device.native;
        console.log('device_index: ' + device_index);
        console.log('native: ' + native);
        if(device_index === null){
          this.measuring = false;
          reject();
        }
        this.measuring = true;
        // First call
        this.getData(device_index, native).then((data) => {
          callback(data);
          // Start interval
          let interval = setInterval(() => {
            if(!this.measuring){
              // Exit
              clearInterval(interval);
              resolve();
            } else {
              this.getData(device_index, native).then((data) => {
                callback(data);
              }).catch(() => {
                this.measuring = false;
                reject();
              })
            }
          }, this.measuringInterval);
        }).catch(() => {
          this.measuring = false;
          reject();
        });
      }).catch(() => {
        this.measuring = false;
        reject();
      })
    });
  }

  public stopMeasurement(){
    this.measuring = false;
  }

  private getData(device_index, native){
    return new Promise((resolve, reject) => {
      let url = '';
      if(native){
        url = this.testoNativeUrls[device_index];
        console.log('MeasurementService getData native url = ' + url);
        this.httpNative.get(url, {}, {}).then(data => {
          console.log('MeasurementService.getData native success');
          resolve(JSON.parse(data.data));
        }).catch(error => {
          if(error.status == 404){
            // Testo 300 header code 404 fix
            resolve(JSON.parse(error.error));
          } else if(error.status != -1){
            console.log('MeasurementService.getData native error');
            console.error(JSON.stringify(error));
            reject();
          }
        });
      } else {
        url = this.testoUrls[device_index];
        console.log('MeasurementService getData HttpClient url = ' + url);
        this.http.get(url).timeout(this.measuringInterval).subscribe((data) => {
          console.log('MeasurementService.getData HttpClient success');
          resolve(data);
        }, (error) => {
          console.log('MeasurementService.getData HttpClient error');
          console.error(JSON.stringify(error));
          reject();
        });
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/services/measurement.service.ts